"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpWWAssessmentDecorator = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_helmet_1 = require("react-helmet");
var DpWWAssessmentDecorator = function (_a) {
    var isWitAndWisdom = _a.isWitAndWisdom, children = _a.children;
    var hostName = window.location.hostname.split('.')[1];
    var fileSource = hostName === 'stage' || hostName === 'dev' ? hostName : 'prod';
    var fileUrl = "https://cdn.digital.greatminds.org/assessments/ww-styles.".concat(fileSource, ".min.css");
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isWitAndWisdom ? ((0, jsx_runtime_1.jsxs)("div", { className: "ww-assess", children: [(0, jsx_runtime_1.jsx)(react_helmet_1.Helmet, { children: (0, jsx_runtime_1.jsx)("link", { rel: "stylesheet", type: "text/css", href: fileUrl }) }), children] })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children })) }));
};
exports.DpWWAssessmentDecorator = DpWWAssessmentDecorator;
exports.default = exports.DpWWAssessmentDecorator;
